import { Avatar, Box, Button, Typography, useMediaQuery, Dialog, DialogTitle, DialogContent, DialogActions, TextField } from '@mui/material';
import React, { useState, useRef, useEffect, useContext } from 'react';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import ColorThief from 'colorthief';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import Frame2121453880 from '../../Assets/promotionalBannar/Frame2121453880.png';
import Frame2121453881 from '../../Assets/promotionalBannar/Frame2121453881.png';
import Frame2121453882 from '../../Assets/promotionalBannar/Frame2121453882.png';
import Frame2121453883 from '../../Assets/promotionalBannar/Frame2121453883.png';
import Frame2121453884 from '../../Assets/promotionalBannar/Frame2121453884.png';
import { AuthContext } from '../../Helpers/Contexts/authContext';
import { createProspect, getBusinesses, updateExpressedInterest } from '../../Utils/apiService';
import { useSnackbar } from 'notistack';

const PromotionalBanner = () => {
    const [activeIndex, setActiveIndex] = useState(0);
    const isMobile = useMediaQuery('(max-width:600px)');
    const { state: { user } } = useContext(AuthContext);
    const [promotionalDatas, setPromotionalData] = useState([]);
    const [expressedBusinessInterests, setExpressedBusinessInterests] = useState<any[]>([]);
    const { enqueueSnackbar } = useSnackbar();
    const fetchBusinesses = async () => {
        if (user?.applicantId) {
            const response = await getBusinesses(user.applicantId);
            console.log(response, "response");
            setPromotionalData(response?.data?.data?.allBusinesses || []);
            setExpressedBusinessInterests(response?.data?.data?.expressedBusinessInterests || []);
        }
    };

    useEffect(() => {
        fetchBusinesses();
    }, [user?.applicantId]);

    const promotionalData = promotionalDatas
        .filter((item: any) => item.Is_Active__c && item.Is_Portal_Promotion_Allowed__c)
        .map((item: any) => ({
            id: item.Id,
            logo: item.Logo_URL__c,
            brandColor: '#f68026',
            title: item.Name,
            tagline: item.Business_Type__c,
            location: item.Business_Address__c,
            phone: item.Phone,
            avatar: item.Business_Directories__r?.records?.[0]?.Contact__r?.Profile_Picture_URL__c,
            name: item.Business_Directories__r?.records?.[0]?.Contact__r?.Name,
            RecordTypeId: item.RecordTypeId,
        }));

    const bgImages = [
        Frame2121453880,
        Frame2121453881,
        Frame2121453882,
        Frame2121453883,
        Frame2121453884,
    ];

    const [interestDialogOpen, setInterestDialogOpen] = useState(false);
    const [interestSubject, setInterestSubject] = useState('');
    const [interestMessage, setInterestMessage] = useState('');
    const [selectedBusiness, setSelectedBusiness] = useState<{ id: string; name: string; title: string; RecordTypeId: string } | null>(null);
    const [isLoading, setIsLoading] = useState(false);

    // Auto-slide every 1 second
    useEffect(() => {
        const interval = setInterval(() => {
            setActiveIndex(prev => (prev + 1) % promotionalData.length);
        }, 5000);
        return () => clearInterval(interval);
    }, [promotionalData.length]);

    // Extract dominant color from logo image

    const handleOpenInterestDialog = (business: any) => {
        setSelectedBusiness(business);
        setInterestDialogOpen(true);
        setInterestSubject('');
        setInterestMessage('');
    };

    const handleCloseInterestDialog = () => {
        setInterestDialogOpen(false);
        setInterestSubject('');
        setInterestMessage('');
        setSelectedBusiness(null);
    };
    console.log(selectedBusiness, "selectedBusiness12345321345");
    
    const handleInterestSubmit = async () => {
        if (!selectedBusiness || !interestSubject || !interestMessage) {
            console.error('Subject and message are required.');
            return;
        }

        setIsLoading(true);
        try {
            const interestData = hasExpressedInterest(selectedBusiness.id);
            if (interestData.expressed) {
                await updateExpressedInterest(interestData.interestId, true);
                enqueueSnackbar({ message: 'Request raised successfully', variant: 'success', autoHideDuration: 1000 });
                await fetchBusinesses();
            } else {
                await createProspect({
                    businessId: selectedBusiness.id,
                    contactId: user?.applicantId || '',
                    message: interestMessage,
                    subject: interestSubject,
                    recordTypeId: selectedBusiness?.RecordTypeId
                });
                enqueueSnackbar({ message: 'Request raised successfully', variant: 'success', autoHideDuration: 1000 });
            }
            handleCloseInterestDialog();
        } catch (error) {
            console.error('Error creating prospect:', error);
            enqueueSnackbar({ message: 'Request raised failed', variant: 'error', autoHideDuration: 1000 });
        } finally {
            setIsLoading(false);
        }
    };

    const handleRemoveInterest = async (interestId: string, currentStatus: boolean) => {
        setIsLoading(true);
        try {
            await updateExpressedInterest(interestId, !currentStatus);
            enqueueSnackbar({ message: 'Request removed successfully', variant: 'success', autoHideDuration: 1000 });
            await fetchBusinesses();
        } catch (error) {
            console.error('Error removing interest:', error);
        } finally {
            setIsLoading(false);
        }
    };

    const hasExpressedInterest = (businessId: string) => {
        const found = expressedBusinessInterests.find(
            (interest: any) => interest.Business__c === businessId
        );
        return {
            expressed: !!found,
            status: found?.Expressed_Interest__c ?? false,
            interestId: found?.Id
        };
    };

    return (
        <>
            {promotionalData.length > 0 ? (
                <Box
                    sx={{
                        borderRadius: isMobile ? "0px" : '22px',
                        overflow: 'hidden',
                        height: isMobile ? "109px" : 160,
                        position: 'relative',
                        backgroundImage: `url(${Frame2121453880})`,
                        marginBottom: "20px"
                    }}
                >
                    {/* Slider Container */}
                    <Box
                        sx={{
                            width: '100%',
                            height: '100%',
                            overflow: 'hidden',
                            position: 'relative'
                        }}
                    >
                        {/* Slides Wrapper */}
                        <Box
                            sx={{
                                display: 'flex',
                                height: '100%',
                                transition: 'transform 0.8s cubic-bezier(0.6,0,0.4,1)',
                                transform: `translateX(-${activeIndex * 100}%)`
                            }}
                        >
                            {promotionalData.map((data, idx) => {
                                const { expressed, status, interestId } = hasExpressedInterest(data.id);
                                return (
                                    <Box
                                    onClick={() => {
                                        if (isMobile) {
                                            handleOpenInterestDialog(data);
                                        }
                                    }}
                                        key={idx}
                                        sx={{
                                            minWidth: '100%',
                                            display: 'flex',
                                            height: '100%',
                                            alignItems: 'center',
                                            px: isMobile ? "10px" : 3,
                                        }}
                                    >
                                        {/* Logo Section */}
                                        <Box
                                            sx={{
                                                width: isMobile ? "70px" : 120,
                                                height: isMobile ? "70px" : 120,
                                                borderRadius: isMobile ? "50%" : "16px",
                                                backgroundColor: "white",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                boxShadow: 2,
                                                mr: isMobile ? 2 : 3,
                                            }}
                                        >
                                            <img
                                                style={{
                                                    width: isMobile ? "70px" : 80,
                                                    height: isMobile ? "70px" : 80,
                                                    borderRadius: "50%",
                                                    padding: "3px",
                                                    objectFit: "cover"
                                                }}
                                                src={data.logo}
                                                alt=""
                                            />
                                        </Box>
                                        {/* Info section */}
                                        <Box sx={{ flex: 1, minWidth: isMobile ? null : 0 }}>
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                                <Typography fontWeight={600} fontSize={isMobile ? "16px" : 20} color="white">{data.title}</Typography>
                                                <Box
                                                    sx={{
                                                        px: 2,
                                                        py: 0.5,
                                                        backgroundColor: 'white',
                                                        fontSize: 12,
                                                        borderRadius: '20px',
                                                        display: 'inline-block'
                                                    }}
                                                >
                                                    <Typography variant="caption" fontSize={isMobile ? 10 : 12} color="black">{data.tagline}</Typography>
                                                </Box>
                                            </Box>
                                            <Box
                                                mt={2}
                                                sx={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: 1,
                                                    width: '100%',
                                                    whiteSpace: 'nowrap',
                                                    overflow: 'hidden',
                                                    textOverflow: 'ellipsis',
                                                }}
                                            >
                                                <Box
                                                    sx={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        py: 0.5,
                                                        color: 'white',
                                                        fontWeight: 500,
                                                        width: '100%',
                                                        textOverflow: 'ellipsis',
                                                    }}
                                                >
                                                    <span style={{ backgroundColor: "#FFFFFF1F", padding: '4px 10px', borderRadius: '50px', fontSize: 12 }}>
                                                        <LocationOnIcon sx={{ fontSize: 18, mr: 0.5 }} />
                                                        {data.location}
                                                    </span>
                                                    <span style={{ marginLeft: '10px', backgroundColor: "#FFFFFF1F", padding: '4px 10px', fontSize: 12, borderRadius: '50px' }}>
                                                        <LocalPhoneIcon sx={{ fontSize: 18, mr: 0.5 }} />
                                                        {data.phone}
                                                    </span>
                                                </Box>
                                            </Box>
                                        </Box>
                                        {/* Avatar & CTA */}
                                        {!isMobile && (
                                            <Box sx={{ display: 'flex', alignItems: 'center', textAlign: "center", alignSelf: 'flex-start', gap: 2, ml: 3, mt: 1 }}>
                                                <Avatar src={data.avatar} sx={{ width: 35, height: 35 }} />
                                                <Typography color="white" fontWeight={500} fontSize={14}>{data.name}</Typography>
                                                <Button
                                                    sx={{
                                                        background: '#2C60AA',
                                                        borderRadius: '10px',
                                                        color: '#fff',
                                                        textTransform: 'none',
                                                        px: 2,
                                                        fontWeight: 600,
                                                        boxShadow: 1,
                                                        fontSize: 12,
                                                    }}
                                                    onClick={() => {
                                                        if (isLoading) return;
                                                        const interestData = hasExpressedInterest(data.id);
                                                        if (interestData.expressed && interestData.status) {
                                                            handleRemoveInterest(interestData.interestId, interestData.status);
                                                        } else {
                                                            handleOpenInterestDialog(data);
                                                        }
                                                    }}
                                                    disabled={isLoading}
                                                >
                                                    {isLoading
                                                        ? "Processing..."
                                                        : (expressed && status ? "Remove Interest" : "Express Interest")}
                                                </Button>
                                            </Box>
                                        )}
                                    </Box>
                                );
                            })}
                        </Box>
                    </Box>
                    {/* Dots */}
                    <Box
                        sx={{
                            position: 'absolute',
                            bottom: 8,
                            left: '50%',
                            transform: 'translateX(-50%)',
                            display: 'flex',
                            gap: 1
                        }}
                    >
                        {promotionalData.map((_, i) => (
                            <Box
                                key={i}
                                onClick={() => setActiveIndex(i)}
                                sx={{
                                    width: 8,
                                    height: 8,
                                    borderRadius: '50%',
                                    backgroundColor: i === activeIndex ? 'white' : 'rgba(255,255,255,0.4)',
                                    cursor: 'pointer'
                                }}
                            />
                        ))}
                    </Box>
                    <Dialog
                        open={interestDialogOpen}
                        onClose={handleCloseInterestDialog}
                        fullWidth
                        maxWidth="sm"
                        PaperProps={{
                            sx: {
                                borderRadius: '16px',
                                margin: { xs: 2, sm: 'auto' },
                                width: { xs: 'calc(100% - 32px)', sm: '100%' }
                            }
                        }}
                    >
                        <DialogTitle sx={{
                            borderBottom: '1px solid #D1D4DB',
                            fontSize: isMobile ?"16px":'20px',
                            fontWeight: '600'
                        }}>
                            Get in touch with {selectedBusiness?.title}
                        </DialogTitle>
                        <DialogContent sx={{ mt: 2, p: 3 }}>
                            <Typography sx={{ mb: 1, fontWeight: 500 }}>
                                Subject<Box component="span" sx={{ color: 'error.main' }}>*</Box>
                            </Typography>
                            <TextField
                                fullWidth
                                placeholder="Interested in your products..."
                                value={interestSubject}
                                onChange={(e) => setInterestSubject(e.target.value)}
                                variant="outlined"
                                required
                            />
                            <Typography sx={{ mb: 1, mt: 3, fontWeight: 500 }}>
                                Your message<Box component="span" sx={{ color: 'error.main' }}>*</Box>
                            </Typography>
                            <TextField
                                fullWidth
                                multiline
                                rows={4}
                                placeholder="Write your message here..."
                                value={interestMessage}
                                onChange={(e) => setInterestMessage(e.target.value)}
                                variant="outlined"
                                required
                            />
                        </DialogContent>
                        <DialogActions sx={{ p: 3, pt: 1, justifyContent: 'flex-end' }}>
                            <Button
                                onClick={handleCloseInterestDialog}
                                sx={{
                                    color: 'text.secondary',
                                    textTransform: 'none',
                                    '&:hover': { backgroundColor: 'transparent' }
                                }}
                            >
                                Cancel
                            </Button>
                            <Button
                                onClick={handleInterestSubmit}
                                variant="contained"
                                disabled={isLoading}
                                sx={{
                                    textTransform: 'none',
                                    padding: '8px 22px',
                                    borderRadius: '8px',
                                    color: "#fff",
                                    background: '#2C60AA !important',
                                    '&:hover': {
                                        background: '#2C60AA !important',
                                    },
                                }}
                            >
                                {isLoading ? 'Submitting...' : 'Raise request'}
                            </Button>
                        </DialogActions>
                    </Dialog>
                </Box>
            ) : (
                null
            )}
        </>

    );
};

export default PromotionalBanner;
